
import { Auth } from "aws-amplify";
import { useEffect } from "react";

function SignOut(): JSX.Element {

    useEffect(() => {
        Auth.signOut();
    }, []);

    return <div />;
}
export default SignOut;